module.exports = __webpack_public_path__ + "static/media/digital.88811bf5.png";